import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { clearModal } from '../../actions/modal';
import { ENGAGEMENT_SCORE } from '../../utils/static-configuration';

class EngagementScoreModal extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  componentWillUnmount() {
    this.onClearModal();
  }

  onOutsideClick = event => {
    const isClickInside = this.refs.modal_content.contains(event.target);
    if (!isClickInside) {
      this.onClearModal();
    }
  };

  onClearModal = () => {
    this.props.onClearModal();
  };

  render() {
    const { showModal, modalLoading } = this.props;

    return (
      <div className={showModal === ENGAGEMENT_SCORE ? 'analytics-modal visible' : 'analytics-modal'} onClick={this.onOutsideClick} >
        <div className="modal-content" ref="modal_content">
          <div className="top">
            <div className="title">
              <img src="/icons/engagement-score.svg" alt="Engagement score" />
              <h3>Dyzio engagement score</h3>
            </div>
            <div className="close">
              <img src="/icons/close.svg" alt="close" onClick={this.onClearModal} />
            </div>
          </div>
          <div className="break" />
          <div className="center">
            <h4>How it works</h4>
            <p>The score is measured using the following criteria:</p>
            <div className="spacer" />
            <img src="/icons/comment-speech.svg" />
            <h4>Comments</h4>
            <p>Score based on number of comments as a percentage of views</p>
            <div className="spacer small" />
            <div className="engagement-labels">
              <div className="flex-item align-left">
                <p className="light">0%</p>
              </div>
              <div className="flex-item align-center">
                <p className="light">0.5%</p>
              </div>
              <div className="flex-item align-right">
                <p className="light">1+%</p>
              </div>
            </div>
            <img
              className="engagement-line"
              src="/icons/engagement-line.svg"
              alt="line break"
            />
            <div className="engagement-labels">
              <div className="flex-item align-left">
                <p>0</p>
              </div>
              <div className="flex-item align-center">
                <p>25</p>
              </div>
              <div className="flex-item align-right">
                <p>50</p>
              </div>
            </div>
            <div className="spacer" />
            <img src="/icons/thumbs-up.svg" />
            <img src="/icons/thumbs-down.svg" />
            <h4>Likes & dislikes</h4>
            <p>Score based on likes minus dislikes as a percentage of views</p>
            <div className="spacer small" />
            <div className="engagement-labels">
              <div className="flex-item align-left">
                <p className="light">0%</p>
              </div>
              <div className="flex-item align-center">
                <p className="light">2.5%</p>
              </div>
              <div className="flex-item align-right">
                <p className="light">5+%</p>
              </div>
            </div>
            <img className="engagement-line" src="/icons/engagement-line.svg" alt="line break" />
            <div className="engagement-labels">
              <div className="flex-item align-left">
                <p>0</p>
              </div>
              <div className="flex-item align-center">
                <p>25</p>
              </div>
              <div className="flex-item align-right">
                <p>50</p>
              </div>
            </div>
            <div className="spacer" />
            <button className="medium rose wide" onClick={this.onClearModal}>
              <p>done</p>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  showModal: state.modal.get('showModal'),
  modalLoading: state.modal.get('loading'),
  modalError: state.modal.get('error'),
});

export function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    onClearModal: () => dispatch(clearModal()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(
  EngagementScoreModal,
);



/** WEBPACK FOOTER **
 ** ./src/components/engagement-score-modal/index.js
 **/